module.exports = __webpack_public_path__ + "media/Nao estou nao.579482eb.mp3";